export const plotTypes = {
  CONSTRUCTION: 'plot-valuation.conversion.plot-types.construction',
  EXPECTED: 'plot-valuation..conversion.plot-types.expected',
  BUSINESS: 'plot-valuation..conversion.plot-types.business',
}
